var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEatingPlace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.91 0h.38L20 20h-2.63a3.75 3.75 0 0 0-4.57-3.22L15.9 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.23 0H3.71L0 20h2.26a3.75 3.75 0 0 1 3.68-3.33c1.9 0 3.46 1.45 3.69 3.33h1.89l3.71-20ZM5.2 3.33c0-.26.21-.47.48-.47h6.1a.48.48 0 1 1 0 .95h-6.1a.48.48 0 0 1-.48-.48Zm.1 1.43a.48.48 0 0 0 0 .95h6.11a.48.48 0 1 0 0-.95h-6.1Zm-.84 2.38c0-.26.21-.47.47-.47h6.11a.48.48 0 1 1 0 .95h-6.1a.48.48 0 0 1-.48-.48Zm.1 1.43a.48.48 0 0 0 0 .95h6.1a.48.48 0 1 0 0-.95h-6.1Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEatingPlace);
export default ForwardRef;